import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import { AxiosError } from "axios";
import getErrorProperty from "./config/getErrorProperty";
import { getAuth } from "firebase/auth";
import { GetForumCategoryDetailResponse } from "../../api/board_category/_id@number";

export type TApiBoardCategoriesResult = {
  result?: GetForumCategoryDetailResponse;
};

export const fetchForumCategoriesDetail = async (category_id: number): Promise<TApiResult & TApiBoardCategoriesResult> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const authHeader = { headers: { Authorization: `Bearer ${token}` } };
  return await client()
    .board_categories._id(category_id).get(authHeader)
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "fetchForumCategoriesDetail");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
